/**
 * Color utilities shared by the LinkTree renderer surfaces.
 * Kept tiny and dependency-free so it stays cheap to import everywhere.
 */

/** Convert a `#rgb` / `#rrggbb` to `rgba(...)`. Falls back to a soft purple
 *  if the input is missing or malformed — never throws. */
export function hexToRgba(hex: string | null | undefined, alpha = 1): string {
  if (!hex || typeof hex !== 'string' || !hex.startsWith('#')) {
    return `rgba(139,92,246,${alpha})`;
  }
  const h = hex.replace('#', '');
  if (!/^[0-9a-fA-F]+$/.test(h) || (h.length !== 3 && h.length !== 6)) {
    return `rgba(139,92,246,${alpha})`;
  }
  const full = h.length === 3 ? h.split('').map(c => c + c).join('') : h;
  const num = parseInt(full, 16);
  const r = (num >> 16) & 255, g = (num >> 8) & 255, b = num & 255;
  return `rgba(${r},${g},${b},${alpha})`;
}
